import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import {
  deleteIncomingQuoteLineItem,
  updateIncomingQuoteLineItem
} from "MODULES/IncomingQuotes/actions";
import { ConfirmAction, ConfirmDelete } from "MODULES/shared/components";
import { AWAITING_REPLY, NO_QUOTE } from "MODULES/IncomingQuotes/constants";
import { STANDARD } from "MODULES/RepairQuotes/constants";
import ConvertToOutgoingQuoteModal from "MODULES/IncomingQuotes/Detail/LineItems/ConvertToOutgoingQuote/ConvertToOutgoingQuoteModal";

function Controls({ deleteItem, updateQuoteType, lineItem }) {
  return (
    <DropDown>
      {lineItem.quote_type === AWAITING_REPLY && (
        <DropDownItem
          id={NO_QUOTE}
          label="No Quote"
          faIcon="exchange"
          renderActive={
            <ConfirmAction onConfirm={updateQuoteType} btnText="Confirm">
              <div>
                Are you sure you want to change the Incoming Quote type to
                &quot;No Quote&quot;?
              </div>
            </ConfirmAction>
          }
        />
      )}
      <DropDownItem
        hideIf={lineItem.quote_type !== STANDARD}
        label="Convert To Outgoing Quote"
        id="convert-to-quote"
        faIcon="refresh"
        renderActive={<ConvertToOutgoingQuoteModal lineItem={lineItem} />}
      />
      <DropDownItem
        id="delete"
        label="Delete"
        faIcon="ban"
        renderActive={<ConfirmDelete onConfirm={deleteItem} />}
      />
    </DropDown>
  );
}

Controls.propTypes = {
  lineItem: PropTypes.shape({
    quote_type: PropTypes.string
  }).isRequired,
  deleteItem: PropTypes.func.isRequired,
  updateQuoteType: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, { lineItem: { id } }) => ({
  deleteItem: () => dispatch(deleteIncomingQuoteLineItem(id)),
  updateQuoteType: () =>
    dispatch(updateIncomingQuoteLineItem({ quote_type: NO_QUOTE }, id))
}))(Controls);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/LineItems/Controls.jsx